<ion-header>
  <ion-toolbar>
    <ion-title>Video Board Authorization</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @defer (when loaded()) {
    <form [formGroup]="form">
      <ion-list  class="content-width">
        <ion-item>
          <ion-input type="text" label="Device name" labelPlacement="floating" formControlName="name"></ion-input>      
        </ion-item>

        <ion-item>
          <ion-select label="Select venue" labelPlacement="floating" interface="popover" formControlName="_venueId" (ionChange)="onVenueSelect($event)">
            @for (venue of venues(); track $index) {
              <ion-select-option [value]="venue._id">{{ venue.venueName }}</ion-select-option>
            }
          </ion-select>
        </ion-item>

        <ion-item>
          <ion-select label="Location" labelPlacement="floating" interface="popover" formControlName="court">
            @for (court of courts; track $index) {
              <ion-select-option [value]="court._id">{{ court.courtName }}</ion-select-option>
            }
          </ion-select>
        </ion-item>

        <!-- <ion-item>
          <ion-select label="Default View" labelPlacement="floating" interface="popover" formControlName="default_view">
            <ion-select-option value="">Match Scoreboard</ion-select-option>
          </ion-select>
        </ion-item> -->

        <ion-button class="ion-margin" (click)="authorizeVenue()" expand="block">
          Authorize
        </ion-button>
      </ion-list>
    </form>
  } @loading(minimum 0.6s) {
    <div class="ion-padding content-width">
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    </div>

    <div class="ion-padding content-width">
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    </div>
  }


</ion-content>